define('formkit/extend.util',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  var _  = require('underscore');
  var Mn = require('marionette');

  var ExtendUtil = {
    extendBehaviors: function(superBehaviors, childBehaviors) {
      var newBehaviors = null;
      if (_.isFunction(superBehaviors) || _.isFunction(childBehaviors)) {
        newBehaviors = (function(superBehaviors, childBehaviors) {
          return function() {
            return _.extend({},
              Mn._getValue(superBehaviors, this),
              Mn._getValue(childBehaviors, this)
            );
          };
        })(superBehaviors, childBehaviors);
      } else {
        newBehaviors = _.extend({}, superBehaviors, childBehaviors);
      }

      return newBehaviors;
    },
    extendClassBehaviors: function(ChildViewClass, childViewOptions) {
      if (ChildViewClass && childViewOptions && childViewOptions.behaviors) {
        ChildViewClass = ChildViewClass.extend({
          behaviors: ExtendUtil.extendBehaviors(ChildViewClass.prototype.behaviors, childViewOptions.behaviors)
        });
      }
      return ChildViewClass;
    }
  }

  module.exports = ExtendUtil;
});

